import React, { useContext, useMemo } from 'react';

import { bool } from 'prop-types';
import { useSelector } from 'react-redux';

import picsioConfig from '../../../../../config';
import { isRouteProductCatalog } from '../../helpers/history';
import MediaLibraryModalQueryContext from '../MediaLibraryModal/MediaLibraryModalQueryContext';
import SearchFiltersToriut from './ToriutSearchFilters/index';
import SearchFilters from './SearchFilters';

const SearchFiltersContainer = ({ onlyTextSearch, searchFilters }) => {
  const location = useSelector((state) => state.router.location);
  const mediaLibraryQueryContext = useContext(MediaLibraryModalQueryContext);

  const isToriutMedia = useMemo(
    () => picsioConfig.isPim && (
      Boolean(mediaLibraryQueryContext) || !isRouteProductCatalog(location.pathname)
    ),
    [location.pathname, mediaLibraryQueryContext],
  );

  return (
    <Choose>
      <When condition={isToriutMedia}>
        <SearchFiltersToriut onlyTextSearch={onlyTextSearch} />
      </When>
      <Otherwise>
        <SearchFilters
          onlyTextSearch={onlyTextSearch}
          searchFilters={searchFilters}
        />
      </Otherwise>
    </Choose>
  );
};

SearchFiltersContainer.propTypes = {
  onlyTextSearch: bool,
  searchFilters: bool,
};

SearchFiltersContainer.defaultProps = {
  onlyTextSearch: false,
  searchFilters: false,
};

export default SearchFiltersContainer;
